// Sustemia · Balance Hídrico · clasificación del residuo (IWA/AWWA M36)
// Portado de Sustemia_BalanceHidrico_Modulo_ES_v1_2026-08-11.html (CLASES).
//
// Las tres clases de IWA/AWWA M36, más una cuarta que Sustemia agrega a
// propósito (ver Fuentes.md §2, "categoría todavía no lo identificamos").
// Obligar a repartir el 100% de la diferencia es exactamente lo que produce
// números inventados: si no queda dónde poner lo que no se sabe, se mete en
// cualquier lado.

export const CLASES_RESIDUO = {
  real: {
    id: "real",
    nombre: "Pérdida real",
    descripcion: "El agua se fue de verdad. Está en el suelo, en el aire o en la calle.",
    porQueImporta: "Esto es lo que se puede recuperar. Cada m³ acá tiene un costo y una reparación asociada.",
    subcategorias: ["Fuga en red enterrada", "Rebalse de tanque", "Rotura de cañería", "Válvula que pasa", "Conexión abierta sin uso"],
  },
  aparente: {
    id: "aparente",
    nombre: "Pérdida aparente",
    descripcion: "El agua no se perdió en ningún lado: el número está mal.",
    porQueImporta: "No se arregla con una cuadrilla, se arregla con medición. Va derecho al plan de medición.",
    subcategorias: ["Error del medidor", "Error de la estimación", "Error de transcripción", "Doble conteo", "Períodos que no empalman"],
  },
  autorizado: {
    id: "autorizado",
    nombre: "Consumo no medido pero autorizado",
    descripcion: "Se usó a propósito y nadie lo midió.",
    porQueImporta: "No es una pérdida. Es consumo que existe y que todavía no tiene medidor.",
    subcategorias: ["Limpieza de instalaciones", "Simulacros y sistema de incendio", "Pruebas hidráulicas", "Riego eventual", "Consumo de obra o mantenimiento"],
  },
  sin_identificar: {
    id: "sin_identificar",
    nombre: "Todavía no lo identificamos",
    descripcion: "No se sabe de dónde salió. Decirlo es mejor que inventarlo.",
    porQueImporta: "Queda visible en el informe. Un residuo declarado se sostiene; un reparto sin respaldo, no.",
    subcategorias: ["Pendiente de investigar"],
    // Categoría agregada por Sustemia, cuarta a las tres de M36 — ver
    // Fuentes.md §2. No sale de una fuente publicada.
    criterioPropio: true,
  },
};

export default { CLASES_RESIDUO };
